import { EventAuth } from './event-auth.js';
import { anonymousAuth } from './anonymous-auth.js';

export function fallbackAuth(auth: EventAuth | null | undefined): EventAuth {
  return auth ?? anonymousAuth();
}
